import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const ReportInfoCard = styled.div`
  width: 400px;
  height: calc(100vh - 120px);
  background-color: ${ColorSF2.white};
  box-shadow: 0px 3px 6px ${ColorSF2.transparentShadow};
  opacity: 1;
  margin: 20px;
  overflow: auto;
`;

export const SectionTitle = styled.p`
  margin: 0;
  font-weight: 600;
  font-size: 16px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const PageInfo = styled.div`
  font-size: 16px;
`;

export const Section = styled.div`
  position: relative;
  flex: 1;
  border-bottom: 1px solid ${ColorSF2.mediumGray};
  padding: 10px 10px;
`;
